module.exports = __webpack_public_path__ + "static/img/light2.a1575eef.png";